module.exports = __webpack_public_path__ + "static/media/open.69a8b766.svg";